import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";

import Table from "../../../Components/Table/Table";

import { helpers } from "@acadia-ui/theme";

import DataStore from "../../../Flux/Stores/CreativesDataStore";
import { fetchCreatives } from "../../../Flux/Actions/CreativesActions";
import LegacyCreativesView from "../features/LegacyViews/LegacyCreativeView";

const classNameComponent = `gos-workbook__auditlevel-creative`;
const classNamePrefix = `${classNameComponent}__`;

export default function useCreative({
	// this comment exists to prevent eslint from making this unreadable.
	auditLevel,
	parentCampaignUniqueID,
	metaData,
	auditLevels,
	fetchMetaData
}) {
	const [data, setData] = useState();
	const [config, setConfig] = useState();

	useEffect(() => {
		setData(null);
		setConfig(null);
	}, [parentCampaignUniqueID]);

	const refresh = useCallback(async (parentCampaignUniqueID, auditLevel) => {
		if (parentCampaignUniqueID && auditLevel) {
			try {
				await fetchCreatives(
					{
						platform: { value: auditLevel.PlatformID },
						auditlevel: { value: auditLevel.AuditLevelID }
					},
					parentCampaignUniqueID
				);
				setData(DataStore.getData());
				setConfig(DataStore.getConfig());
			} catch (e) {
				setData(null);
				setConfig(null);
			}
		}
	}, []);

	helpers.useAsyncEffect(() => {
		if (parentCampaignUniqueID && auditLevel && metaData.CampaignUniqueIDCode == parentCampaignUniqueID && auditLevel.PlatformID == metaData.PlatformID) {
			refresh(parentCampaignUniqueID, auditLevel);
		}
	}, [parentCampaignUniqueID, auditLevel]);

	const Component = useCallback(
		({ refreshMap }) => {
			if (data && config && metaData && fetchMetaData) {
				return (
					<div className={`gos-workbook__auditlevel ${classNameComponent}`}>
						<LegacyCreativesView
							// this comment exists to prevent eslint from making this unreadable.
							campaignMetaData={metaData}
							auditLevelData={auditLevels}
							getCount={() => {}}
							getPlacementCount={() => {}}
							updateCounts={() =>
								// eslint-disable-next-line
								refreshMap?.["Creative"]?.()
							}
							updateMetaData={fetchMetaData}
						/>
					</div>
				);
			}
			return <></>;
		},
		[config, data, metaData, fetchMetaData]
	);

	return useMemo(
		() => ({
			Component,
			data,
			refresh
		}),
		[Component, data, refresh]
	);
}
